__webpack_require__.p = "https://product-search.qa.core-artifacts.com/static/";